import { Component, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NotificationRequest } from '../../../../models/notification-request';
import { NotificationService } from '../../../../services/notification/notification.service';
import { SharedService } from '../../../../services/shared/shared.service';
import { AuthServiceService } from '../../../../services/authService/auth-service.service';

@Component({
  selector: 'app-notifications',
  imports: [CommonModule],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.css'
})
export class NotificationsComponent {
  userUid:any;
  notifications=new Array<NotificationRequest>();
  showSpinner=true;
  constructor(
    private router:ActivatedRoute,
    private notificationService:NotificationService,
    public sharedService:SharedService,
    private authService:AuthServiceService
  ){}
  ngOnInit(){
    this.userUid=this.authService.getCurrentUserUid();
    this.getNotifications();
  }
  getNotifications(){
    this.notificationService.getNotificationsByUserUid(this.userUid).subscribe({
      next:res=>{
        this.notifications=res;
        this.showSpinner=false
      },
        
      error:err=>{
        this.showSpinner=false
      }
    })
  }



  
  toggleDropdown(notification: any) {
      this.notifications.forEach(n => n.isOpen = n === notification ? !n.isOpen : false);
    }
  
    markAsRead(notification: any) {
      notification.status = 'READ';
      notification.isOpen = false;
      this.notificationService.markNotificationAsRead(this.userUid,notification.id);
    }
  
    deleteNotification(notification: any) {
      this.notificationService.deleteNotification(this.userUid,notification.id);
    }
  
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
      const target = event.target as HTMLElement;
      if (!target.closest('.position-relative')) {
        this.notifications.forEach(n => n.isOpen = false);
      }
    }





}
